import React from 'react';

import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonSmallText from '../../../common-components/common-small-text';

const list = [
    {
        text: 'Главная задача&nbsp;&mdash; охват предпринимателей, которые занимаются или планируют заниматься экспортом. Российский экспортный центр может помочь им&nbsp;с&nbsp;документацией и&nbsp;конкурентным анализом рынка',
        img: '/images/svg/rec/rec-tasks-points__img1.svg',
    },
    {
        text: 'Обеспечить рост достижения промежуточных целей&nbsp;&mdash; скачивание различных пособий с&nbsp;сайта РЭЦ, чтобы понять заинтересованность приходящего трафика',
        img: '/images/svg/rec/rec-tasks-points__img2.svg',
    },
    {
        text: 'Повысить количество регистраций личных кабинетов юридических лиц&nbsp;&mdash; потенциальных экспортеров ',
        img: '/images/svg/rec/rec-tasks-points__img3.svg',
    },
    {
        text: 'Вывести высокочастотный ключ &laquo;Экспорт&raquo; в&nbsp;ТОП-10 органической выдачи',
        img: '/images/svg/rec/rec-tasks-points__img4.svg',
    },
];

const Tasks = () => {
    return (
        <ScrollAnimation delay={0} animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper className="rec-tasks" bigPaddings={true} isMargin={false}>
                <CommonTitle>Задачи</CommonTitle>
                <CommonUsualText className="rec-tasks__subtitle">
                    С&nbsp;помощью контекстной рекламы и&nbsp;поисковой оптимизации повысить охват
                    и&nbsp;рост целевого трафика
                </CommonUsualText>
                <div className="rec-tasks-points">
                    {list.map(({ img, text }, index) => (
                        <div className="rec-tasks-points__item" key={index}>
                            <div className="rec-tasks-points__img">
                                <img src={img} alt="" loading="lazy" />
                            </div>
                            <CommonSmallText className="rec-tasks-points__text">
                                {parse(text)}
                            </CommonSmallText>
                        </div>
                    ))}
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Tasks;
